import { useEffect, useState } from 'react';
import styled from 'threads5/styles/styled';
import { ITheme as PlaidTheme } from 'threads5/themes/theme';
import SxProps from 'threads5/themes/sx-props';
import { NEXT_PUBLIC_PERCY_RUN } from 'src/env';

const StyledOneTrustButton = styled('button')({
  padding: 0,
  margin: 0,
  border: 'none',
  color: '#fff',
  '&:hover': {
    color: '#63daff',
  },
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
  fontWeight: '600',
  svg: {
    with: 'auto',
    height: '20px',
  },
});
export type OneTrustButtonProps = {
  sx?: SxProps<PlaidTheme>;
};
export default function OneTrustButton(props: OneTrustButtonProps) {
  const [oneTrustLoaded, setOneTrustLoaded] = useState(false);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (!!window.OneTrust) {
        setOneTrustLoaded(true);
        return;
      }

      // if OneTrust isn't loaded, try waiting for it a bit.
      // try 20 times then bail
      let ticks = 20;
      const maybeOneTrust = setInterval(() => {
        ticks--;
        if (!!window.OneTrust) {
          setOneTrustLoaded(!!window.OneTrust);
          clearInterval(maybeOneTrust);
        }
        if (ticks <= 0) {
          clearInterval(maybeOneTrust);
        }
      }, 100);

      return () => {
        return clearInterval(maybeOneTrust);
      };
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (oneTrustLoaded) {
        // if the floater cookie image is there, remove it
        const floater = document.getElementById('ot-sdk-btn-floating');
        if (floater) {
          floater.style.display = 'none';
        }

        // add css class to body to enable styles to hide the floater cookie image
        document.body.classList.add('ot-v2');

        if (NEXT_PUBLIC_PERCY_RUN) {
          // hide the banner when percy is taking screenshots
          document.body.classList.add('is-percy');
        }
      }
    }
  }, [oneTrustLoaded]);

  if (!oneTrustLoaded) return null;

  return (
    <StyledOneTrustButton
      onClick={() => {
        window?.OneTrust?.ToggleInfoDisplay();
      }}
      sx={props.sx}
    >
      Your Privacy Choices
    </StyledOneTrustButton>
  );
}
